<div class="container my-5">
  <div class="row justify-content-center">
    <div class="col-md-6">
      <div class="card">
        <div class="card-body">

          <!-- Step 1: Scan QR -->
          <div *ngIf="step === 'loading'" class="text-center">
            <h5>Setting up Authenticator...</h5>
            <p>Please wait.</p>
          </div>

          <div *ngIf="step === 'scan'">
            <h5 class="card-title text-center">Set Up Authenticator App</h5>
            <p class="text-center">
              Scan this QR code with your authenticator app (Google Authenticator, Authy, etc.), then enter the 6-digit code below.
            </p>

            <div class="text-center my-4" *ngIf="qrUri">
              <qrcode [qrdata]="qrUri" [width]="250" errorCorrectionLevel="M"></qrcode>
            </div>

            <div *ngIf="error" class="alert alert-danger">{{ error }}</div>

            <div class="form-group">
              <mat-form-field appearance="fill" style="width: 100%; font-size: 16px">
                <mat-label>6-digit code</mat-label>
                <input matInput [(ngModel)]="code" placeholder="Enter code" maxlength="6" />
              </mat-form-field>
            </div>

            <button mat-raised-button color="accent" class="btn-block" [disabled]="code.length !== 6" (click)="verify()">
              Verify &amp; Enable
            </button>
            <a mat-button color="primary" class="btn-block mt-2" (click)="goToProfile()">Cancel — Return to Profile</a>
          </div>

          <!-- Step 2: Done -->
          <div *ngIf="step === 'done'" class="text-center">
            <h5 class="card-title">Authenticator Enabled</h5>
            <p>Your authenticator app has been set up successfully. You will now be asked for a code each time you sign in.</p>
            <button mat-raised-button color="primary" (click)="goToProfile()">Back to Profile</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>